import {AxiosError, AxiosRequestConfig} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PutUploadFileToS3Request {
  data: File | FormData;
  putUrl: string;
  customHeader?: AxiosRequestConfig;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutUploadToS3 = ({onSuccess, onError}: Input = {}) => {
  const putUploadFileToS3 = async ({data, putUrl, customHeader}: PutUploadFileToS3Request) => {
    await axiosClient.put<void>(putUrl, data, customHeader ? {...customHeader} : undefined);
  };

  return useCustomMutation(
      putUploadFileToS3,
      {
        onSuccess,
        onError,
      },
      false
  );
};
